import { action } from '@reatom/framework'

import { redirectToLastVisitedNonAuthRouteAction } from '@root/features/routing/atoms'
import { AuthRoute } from '@root/features/routing/model'
import { isTauriOrBrowserLocalAtom } from '@root/shared/core'
import { routerActions } from '@root/shared/lib/react-router'

import { InitializationState } from '../../model'
import {
  authStateReaction,
  initializationStateAtom,
  initializeInitializationDeepLinksAction,
  meRequestStateReaction,
  secureStorageStateReaction,
} from '../common'
import { initializeUserAction } from '../common/reatom-me'

export const initializeInitializationAction = action((ctx) => {
  if (!ctx.get(isTauriOrBrowserLocalAtom)) {
    initializationStateAtom(ctx, new InitializationState.Website())
    // The same gap as on desktop: without this the web never asks who is
    // signed in, so `userAtom` stays empty for the whole visit.
    initializeUserAction(ctx)
    return
  }

  initializeInitializationDeepLinksAction(ctx)

  routerActions.navigate(ctx, AuthRoute.build())
  authStateReaction(ctx)
  meRequestStateReaction(ctx)
  secureStorageStateReaction(ctx, (ctx) => {
    redirectToLastVisitedNonAuthRouteAction(ctx)
  })

  initializeUserAction(ctx)
}, 'initializeInitializationAction')
